import React, { useEffect, useRef } from 'react';
import waveVideo from '../../../assets/videos/sinewave.mp4';
import './ProcessingSlide.scss';

const AUTO_ADVANCE_DELAY = 3300;

const ProcessingSlide = ({ onNext }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const playVideo = async () => {
      try {
        await video.play();
      } catch (err) {
        // Video autoplay blocked - user interaction may be required
      }
    };

    playVideo();

    const autoAdvanceTimer = setTimeout(() => {
      onNext?.();
    }, AUTO_ADVANCE_DELAY);

    return () => {
      clearTimeout(autoAdvanceTimer);
    };
  }, [onNext]);

  return (
    <div className="slide processing-slide">
      <div className="processing-slide__container">
        <div className="processing-slide__box">
          <div className="processing-slide__text">
            <h2 className="processing-slide__title">
              Configuring your pass. Standby.
            </h2>
          </div>

          <div className="processing-slide__animation">
            <video
              ref={videoRef}
              className="sine-waves"
              src={waveVideo}
              loop
              muted
              playsInline
              preload="auto"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProcessingSlide;
